(function (ws) {
    'use strict';
    ws.models.resellerListingModel = Backbone.Model.extend({
        url: globals.path.api.westcon.getResellerList
    });
}(westcon));
